import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram, faInstagram, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import logo from '../assets/images/logo-sq.jpg'
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useGetLastSixBlogsQuery } from "../Redux/Apis/blogApi";

function toTop() {
    const body = document.querySelector('#ScrollTop');
    body?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
    })
}

function Footer() {
    const {data,isSuccess} = useGetLastSixBlogsQuery();
    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => {
            window.removeEventListener('scroll', stickNavbar);
        };
    }, [])
    
    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            if(windowHeight > 45) {$('.back-to-top').removeClass('d-none'); $('.back-to-top').addClass('d-block')}
            else {$('.back-to-top').removeClass('d-block'); $('.back-to-top').addClass('d-none');}
        }
    };

    return ( 
        <>
        <div className="container-fluid bg-danger text-light footer">
            <div className="container">
                <div className="row gx-5">
                    <div className="col-lg-4 col-md-6 footer-about">
                        <div className="d-flex flex-column align-items-center justify-content-center text-center h-100 p-4 text-dark" style={{background: "#FFE0E0"}}>
                            <div className="row align-items-center mb-2">
                                <Link to="/" className="col-4">
                                    <img src={logo} className="border-start border-bottom border-4 border-danger " alt="GREhub logo" height={80}/>
                                </Link>
                                <div className="col-8 text-left">
                                    <h5 className="text-danger p-0 m-0">وبسایت GREhub</h5>
                                    <h6 className="fw-light p-0 m-0">شبیه ساز آزمون GRE</h6>
                                </div>
                            </div>
                            <p className="mt-4 mb-4" style={{maxWidth: "250px"}}>
                            وبسایت GREhub با شعار آغازی برای پذیرش موفق (A Start to a Successful Admission) همراه شماست تا بهترین نمره را کسب و از هر دانشگاهی که می خواهید پذیرش بگیرید.
                            </p>
                            <button className="btn btn-danger mt-2 py-2 px-5" >رایگان عضو شوید</button>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <div className="row gx-5">
                            <div className="col-lg-4 col-md-12 pt-5 mb-5">
                                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                    <h3 className="text-light mb-0">با ما در ارتباط باشید</h3>
                                </div>
                                <div className="d-flex mb-3">
                                    <FontAwesomeIcon icon="location-dot" className="text-light me-2"></FontAwesomeIcon>
                                    <p className="mb-0">تهران، سعادت آباد، کوی فراز، خیابان بیدار غربی، ساختمان میدکو، طبقه پنجم، واحد 502</p>
                                </div>
                                <div className="d-flex mb-3">
                                    <FontAwesomeIcon icon="envelope-open" className="text-light me-2"></FontAwesomeIcon>
                                    <a href="mailto:info@Grehub.org" className="text-light mb-0">info@grehub.org</a>
                                </div>
                                {/* <div className="d-flex mb-2">
                                    <i className="bi bi-telephone text-primary me-2"></i>
                                    <p className="mb-0">+012 345 67890</p>
                                </div> */}
                                <div className="d-flex mt-4">
                                    <a className="btn btn-danger btn-square me-2" href="https://www.instagram.com/grehub_org"><FontAwesomeIcon icon={faInstagram} className="fw-normal"/></a>
                                    <a className="btn btn-danger btn-square me-2" href="https://T.me/GREhub"><FontAwesomeIcon icon={faTelegram} className="fw-normal"/></a>
                                    <a className="btn btn-danger btn-square" href="https://x.com/GREhub"><FontAwesomeIcon icon={faXTwitter} className="fw-normal"/></a>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                    <h3 className="text-light mb-0">لینک های مفید</h3>
                                </div>
                                <div className="link-animated d-flex flex-column justify-content-start">
                                    <Link className="text-light mb-3" to="/post/52/%D8%A2%D8%B2%D9%85%D9%88%D9%86-gre%D8%8C-%D8%A8%D9%87%D8%AA%D8%B1%DB%8C%D9%86-%D9%85%D9%86%D8%A7%D8%A8%D8%B9-%D8%AE%D9%88%D8%AF%D8%AE%D9%88%D8%A7%D9%86-%D8%A2%D8%B2%D9%85%D9%88%D9%86-gre-%D9%88-%D9%BE%D8%A7%D8%B3%D8%AE-%D8%A8%D9%87-%D8%B3%D9%88%D8%A7%D9%84%D8%A7%D8%AA-%D9%85%D8%AA%D8%AF%D8%A7%D9%88%D9%84-%E2%80%93-%D8%A2%D9%BE%D8%AF%DB%8C%D8%AA-2025"><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>آزمون GRE، بهترین منابع خودخوان آزمون GRE و پاسخ به سوالات متداول – آپدیت 2025 </Link>
                                    <Link className="text-light mb-3" to="/post/45/انواع-اشتراک-در-grehub-"><FontAwesomeIcon icon="arrow-left" className="me-3"></FontAwesomeIcon>انواع اشتراک در GREhub</Link>
                                    <Link className="text-light mb-3" to="/post/54/فیلم-وبینار-رسمی-ets-–-راهنمای-جامع-آزمون-gre-(16-جولای-2024)"><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon> فیلم وبینار رسمی ETS – راهنمای جامع آزمون GRE (16 جولای 2024)</Link>
                                    <a className="text-light mb-3" href="https://ereg.ets.org/ereg/public/jump?_p=GRI" target="_blank" rel="noreferrer"><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>ثبت نام آزمون GRE (ets)</a>
                                    <a className="text-light mb-3" href="https://ets.sanjesh.org/" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>خرید ووچر GRE از سنجش</a>
                                    <Link className="text-light mb-3" to="/post/55/دانلود-دوره-های-گرگمت-gregmat-(gmat-،gre،-تافل،-آیلتس)-آپدیت-2025"><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>دانلود دوره های گرگمت GregMat (GMAT ،GRE، تافل، آیلتس) آپدیت 2025</Link>
                                    <Link className="text-light" to="/post/53/مشاوره-مصاحبه-سفارت-آمریکا-(ویزای-تحصیلی-و-توریستی)"><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>مشاوره مصاحبه سفارت آمریکا (ویزای تحصیلی و توریستی)</Link>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                                    <h3 className="text-light mb-0">آخرین پست ها</h3>
                                </div>
                                <div className="link-animated d-flex flex-column justify-content-start">
                                    {isSuccess && data && data.map((row,index) => 
                                        <Link key={index} className="text-light mb-3" to={`/post/${row.id}/${row.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`}><FontAwesomeIcon icon="arrow-left" className="me-2"></FontAwesomeIcon>{row.title}</Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container-fluid text-white" style={{background: "#840000"}}>
            {/* <div className="container"> */}
                <div className="row justify-content-end px-2">
                    <div className="col-lg-8 col-md-6">
                        <div className="d-md-flex align-items-center justify-content-between py-2" style={{minHeight: "75px"}}>
                            <p className="mb-md-0 ">&copy; تمامی حقوق برای وبسایت <u>GREhub</u> محفوظ می باشد. کپی بدون ذکر منبع پیگرد قانونی دارد. </p>
                            {/* <p className="mb-md-0">ساخته شده با <FontAwesomeIcon icon="heart" className="text-danger"/> در <a href="https://www.linket.me/">لینکت</a></p> */}
                        </div>
                    </div>
                </div>
            {/* </div> */}
        </div>

        <button className="btn btn-lg btn-danger btn-lg-square rounded back-to-top d-none" onClick={toTop}>
            <FontAwesomeIcon icon="arrow-up" />
        </button>
        </>
     );
}

export default Footer;